import { Box, Typography } from '@mui/material'
import { capitalize } from '@tunasong/models'
import type { Entity, Persisted } from '@tunasong/schemas'
import type { FC } from 'react'
import { useDeviceUISettings } from '../hooks/device-ui-settings.js'
import TagList from '../tags/tag-list.js'
import ContentViews from './content-views.js'
import { Divider } from './divider.js'

export interface ContentContainerSettingsProps {
  className?: string
  entity: Persisted<Entity>

  EntityControls?: FC<{ entity?: Persisted<Entity>; onActive?: (active: boolean) => void }>
}

export const ContentContainerSettings: FC<ContentContainerSettingsProps> = props => {
  const { entity, EntityControls, ...restProps } = props

  // Filter by tags
  const { tagsFilter, setTagsFilter } = useDeviceUISettings()

  return (
    // This is the scroll container for the contentEl
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          // hack to avoid opacity flickering
          transform: 'rotate(0)',

          transition: theme =>
            theme.transitions.create('opacity', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
        }}
        {...restProps}
      >
        <Typography variant="subtitle1" sx={{ marginTop: 1, marginBottom: 1 }}>
          Content view
        </Typography>
        <ContentViews entity={entity} />

        <Typography variant="subtitle1" sx={{ marginTop: 1, marginBottom: 1 }}>
          Show by tags
        </Typography>
        <TagList tabIndex={-1} placeholder="Show by tag(s)" tags={tagsFilter} onChange={setTagsFilter} size="small" />

        {EntityControls ? (
          <>
            <Divider>{capitalize(entity.type)} settings</Divider>
            <EntityControls entity={entity} />
          </>
        ) : null}
      </Box>
    </>
  )
}

export default ContentContainerSettings
